export const USER_SCORE_INFO_LABELS = {
  SCORED_BY: 'Scored by',
  SCORED_VIA_INTEGRATION: 'Scored via integration',
  ON_PREFIX: 'on ',
  SCORED_ON_PREFIX: 'Scored on ',
  ESTIMATING_INHERENT_RISK: 'Estimating inherent risk',
} as const
